"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Background color
 */
var VIEW_BG_VIEW;
(function (VIEW_BG_VIEW) {
    VIEW_BG_VIEW["none"] = "none";
    VIEW_BG_VIEW["normal"] = "normal";
    VIEW_BG_VIEW["neutral"] = "neutral";
    VIEW_BG_VIEW["hover"] = "hover";
    VIEW_BG_VIEW["selection"] = "selection";
    VIEW_BG_VIEW["brand"] = "brand";
    VIEW_BG_VIEW["error"] = "error";
    VIEW_BG_VIEW["disabled"] = "disabled";
    VIEW_BG_VIEW["highlight"] = "highlight";
    VIEW_BG_VIEW["highlightDark"] = "highlightDark";
    VIEW_BG_VIEW["highlightInverted"] = "highlightInverted";
    VIEW_BG_VIEW["highlightDarkInverted"] = "highlightDarkInverted";
    VIEW_BG_VIEW["highlightError"] = "highlightError";
    VIEW_BG_VIEW["highlightErrorDark"] = "highlightErrorDark";
})(VIEW_BG_VIEW = exports.VIEW_BG_VIEW || (exports.VIEW_BG_VIEW = {}));
/**
 * Type of available space filling
 */
var SPACE_FILL;
(function (SPACE_FILL) {
    SPACE_FILL["all"] = "all";
})(SPACE_FILL = exports.SPACE_FILL || (exports.SPACE_FILL = {}));
/**
 * Indent size for margin and padding
 */
var INDENT;
(function (INDENT) {
    INDENT["none"] = "none";
    INDENT["xxs"] = "xxs";
    INDENT["xs"] = "xs";
    INDENT["s"] = "s";
    INDENT["m"] = "m";
    INDENT["l"] = "l";
    INDENT["xl"] = "xl";
    INDENT["xxl"] = "xxl";
    INDENT["xxxl"] = "xxxl";
})(INDENT = exports.INDENT || (exports.INDENT = {}));
/**
 * Border color
 */
var VIEW_BORDER;
(function (VIEW_BORDER) {
    VIEW_BORDER["none"] = "none";
    VIEW_BORDER["normal"] = "normal";
    VIEW_BORDER["grid"] = "grid";
    VIEW_BORDER["error"] = "error";
    VIEW_BORDER["brand"] = "brand";
    VIEW_BORDER["disabled"] = "disabled";
})(VIEW_BORDER = exports.VIEW_BORDER || (exports.VIEW_BORDER = {}));
/**
 * Type of shadow
 */
var VIEW_ZDEPTH;
(function (VIEW_ZDEPTH) {
    VIEW_ZDEPTH["none"] = "none";
    VIEW_ZDEPTH["xs"] = "xs";
    VIEW_ZDEPTH["s"] = "s";
    VIEW_ZDEPTH["m"] = "m";
    VIEW_ZDEPTH["l"] = "l";
    VIEW_ZDEPTH["xl"] = "xl";
    VIEW_ZDEPTH["xxl"] = "xxl";
})(VIEW_ZDEPTH = exports.VIEW_ZDEPTH || (exports.VIEW_ZDEPTH = {}));
var VIEW_CONTENT_MOD;
(function (VIEW_CONTENT_MOD) {
    VIEW_CONTENT_MOD["none"] = "none";
    VIEW_CONTENT_MOD["fill"] = "fill";
    VIEW_CONTENT_MOD["center"] = "center";
})(VIEW_CONTENT_MOD = exports.VIEW_CONTENT_MOD || (exports.VIEW_CONTENT_MOD = {}));
var VIEW_ALIGN;
(function (VIEW_ALIGN) {
    VIEW_ALIGN["start"] = "start";
    VIEW_ALIGN["center"] = "center";
    VIEW_ALIGN["end"] = "end";
    VIEW_ALIGN["fill"] = "fill";
})(VIEW_ALIGN = exports.VIEW_ALIGN || (exports.VIEW_ALIGN = {}));
var VIEW_DISTRIBUTION;
(function (VIEW_DISTRIBUTION) {
    VIEW_DISTRIBUTION["fill"] = "fill";
    VIEW_DISTRIBUTION["between"] = "between";
    VIEW_DISTRIBUTION["center"] = "center";
})(VIEW_DISTRIBUTION = exports.VIEW_DISTRIBUTION || (exports.VIEW_DISTRIBUTION = {}));
var VIEW_DIRECTION;
(function (VIEW_DIRECTION) {
    VIEW_DIRECTION["row"] = "row";
    VIEW_DIRECTION["column"] = "column";
})(VIEW_DIRECTION = exports.VIEW_DIRECTION || (exports.VIEW_DIRECTION = {}));
//# sourceMappingURL=types.js.map